import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogIn, Loader2, Hash } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import BrandLogo from "@/components/BrandLogo";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [matricola, setMatricola] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    const digits = matricola.replace(/\D/g, "");
    if (digits.length !== 6) {
      setErr("La matricola deve essere di 6 cifre.");
      return;
    }
    setLoading(true);
    try {
      const u = await login(digits, password);
      const to = loc.state?.from || (u?.must_change_password ? "/change-password" : "/dashboard");
      nav(to, { replace: true });
      toast.success("Bentornato/a!");
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Errore di login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-bg min-h-[70vh] flex items-center justify-center px-4 py-14">
      <div className="card-elevated p-8 max-w-md w-full fade-up">
        <div className="flex justify-center mb-4"><BrandLogo size="lg" withText={false} /></div>
        <h1 className="font-display font-extrabold text-2xl text-[#0B3D91] text-center">Accedi al tuo account</h1>
        <p className="mt-1 text-sm text-[#5A6A94] text-center">Inserisci la tua matricola (6 cifre) e la password fornita dall'amministrazione.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-[#0F1E3D] mb-1.5">Matricola</label>
            <div className="relative">
              <Hash size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8494B8]" />
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                required
                autoComplete="username"
                value={matricola}
                onChange={(e) => setMatricola(e.target.value.replace(/\D/g, "").slice(0, 6))}
                className="warm-input pl-9 tracking-widest font-mono text-lg"
                placeholder="123456"
                data-testid="login-matricola"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#0F1E3D] mb-1.5">Password</label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="warm-input"
              data-testid="login-password"
            />
          </div>
          {err && <p className="text-sm text-[#F97316]" data-testid="login-error">{err}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full !py-3" data-testid="login-submit-btn">
            {loading ? <><Loader2 className="animate-spin" size={16} /> Attendere...</> : <><LogIn size={16} /> Entra</>}
          </button>
          <p className="text-center text-sm">
            <Link to="/forgot-password" className="text-[#F97316] font-semibold hover:underline" data-testid="forgot-pw-link">
              Password dimenticata?
            </Link>
          </p>
        </form>
        <p className="mt-5 text-sm text-center text-[#5A6A94]">
          Non sei ancora iscritto? <Link to="/register" className="text-[#F97316] font-semibold">Iscriviti</Link>
        </p>
      </div>
    </div>
  );
}
